/*
 *
 * This File Containes the Services Required for Loading Constant Data
 *
 */

import ANLogo from "@/assets/logo/Logo.png";
import Image1 from "@/assets/images/carousel-image1.png";
import Image2 from "@/assets/images/carousel-image2.png";
import Image3 from "@/assets/images/carousel-image3.png";
import Image4 from "@/assets/images/carousel-image4.png";
import Dashboard from "@/assets/icons/Dashboard.vue";
import Planning from "@/assets/icons/Planning.vue";
import MyGoals from "@/assets/icons/MyGoals.vue";
import StockScreener from "@/assets/icons/StockScreener.vue";
import StockSelection from "@/assets/icons/StockSelection.vue";
import Analysis from "@/assets/icons/Analysis.vue";
import ContactUs from "@/assets/icons/ContactUs.vue";
import Blogs from "@/assets/icons/Blogs.vue";
import Newsletter from "@/assets/icons/Newsletter.vue";
import StockAnalysis from "@/assets/icons/StockAnalysis.vue";
import UserDashboard from "@/screens/dashboard/UserDashboard.vue";
import PlanningTool from "@/screens/dashboard/PlanningTool.vue";
import BlogsVideos from "@/screens/dashboard/BlogsVideos.vue";
import MyPortfolio from "@/tabs/user-dashboard/MyPortfolio.vue";
import FinancialStatements from "@/tabs/user-dashboard/FinancialStatements.vue";
import ContactUsScreen from "@/screens/dashboard/ContactUs.vue";
import MyGoalsScreen from "@/screens/dashboard/MyGoals.vue";
import StockScreeners from "@/screens/dashboard/StockScreeners.vue";
import PortfolioAnalytics from "@/screens/dashboard/PortfolioAnalytics.vue";
import StockAnalysisView from "@/screens/dashboard/StockAnalysisView.vue";
import MutualFundRecommender from "@/tabs/mutual-fund/MutualFundRecommender.vue";
import ManageUserProfile from "@/components/dashboard/ManageUserProfile.vue";
import AgreementSigning from "@/screens/dashboard/AgreementSigning.vue";
import PaymentQRCode from "@/components/dashboard/PaymentQRCode.vue";
import PaymentStatus from "@/components/dashboard/PaymentStatus.vue";
import KYCVerification from "@/screens/dashboard/KYCView.vue";
import MyModelPortfolio from "@/screens/dashboard/MyModelPortfolio.vue";
import User from "@/assets/icons/User.vue";
import NewBusiness from "@/assets/icons/NewBusiness.vue";
import BuyHome from "@/assets/icons/BuyHome.vue";
import ChildEducation from "@/assets/icons/ChildEducation.vue";
import ChildMarriage from "@/assets/icons/ChildMarriage.vue";
import GettingMarried from "@/assets/icons/GettingMarried.vue";
import Retirement from "@/assets/icons/Retirement.vue";
import { useUserStore } from "@/store/user-store";
import { convertToInr } from "./common-services";
import MonthlyMarketUpdate from "@/screens/dashboard/MonthlyMarketUpdate.vue";

export const headerOptions = {
  logoUrl: ANLogo,
  options: [
    {
      label: "Why Choose Us",
      section: "wcu",
    },
    {
      label: "Services",
      section: "ourServices",
    },
    {
      label: "Risk Assessment",
      section: "riskAssessment",
    },
    {
      label: "Calculators",
      section: "financialCalculators",
    },
    {
      label: "Testimonial",
      section: "testimonial",
    },
    {
      label: "Articles",
      section: "subscribe",
    },
  ],
};

export const carouselData = [
  {
    image: Image1,
    title: "Financial Freedom",
    description:
      "Do you have enough savings, investments, and cash in hand to live the life you always wanted to live for yourself and your family, without relying on anyone!",
  },
  {
    image: Image2,
    title: "Financial Planning",
    description:
      "Balancing your resources & expenses to build wealth is the key to Financial Freedom. Set goals and invest your savings to realize them through appropriate investment products.",
  },
  {
    image: Image3,
    title: "Investment Management",
    description:
      "AssetNivesh will help you decode secrets of wealth management products.",
  },
  {
    image: Image4,
    title: "Investment Advisers",
    description:
      "We, the SEBI registered investment advisers at AssetNivesh, will hand hold you in the journey to Financial Freedom and help you build wealth.",
  },
];


export const wcuData = {
  title: "Offering a platform for\nyour journey to building wealth",
  cardData: [
    {
      title: "Risk Profile Assessment",
      description:
        "Based on your financial networth and personal information about family & lifecycle stage, we asses risk tolerance & appetite",
    },
    {
      title: "Setting Your\nGoals",
      description:
        "Identify your Goals & Prioritize. Set Investment Horizon for short term (e.g. buying house) & long term (e.g. retirement) goals respectively!",
    },
    {
      title: "Portfolio Construction",
      description:
        "Based on Investment Horizon, your preferences, risk profile, we identify adequate financial products.",
    },
    {
      title: "Monitoring Portfolio Performance",
      description:
        "Based on market dynamics & major personal events, we suggest rebalancing portfolio.",
    },
  ],
};

export const osData = {
  title: "Our Services",
  cardData: [
    {
      title: "Data driven Model Portfolio Recommendation",
      description:
        "Based on your risk profile, and, historical performance & forward looking estimation of assets we suggest you an appropriate portfolio!",
    },
    {
      title: "Equity Research Reports",
      description:
        "We help you find & invest in funds based on your needs, expertise, preferences with as low fees as possible!",
    },
    {
      title: "Mutual Fund Advice",
      description:
        "Based on Investment Horizon, your preferences, risk profile, we identify adequate financial products.",
    },
    {
      title: "Retirement Planning",
      description:
        "To help you plan for your retirement, we assess your readiness based on your current state, and then recommend invstements to achieve your goals!",
    },
    {
      title: "Platform to track your Portfolio",
      description: `"Their life investment policies provided us with peace of mind, knowing that our loved ones are financially protected in any circumstance."`,
    },
  ],
};

export const founderData = {
  title: "Asset Nivesh Founders",
  cardData: [
    {
      name: "Vivek Gupta",
      image: Image1,
    },
    {
      name: "Yashvardhan Gupta",
      image: Image1,
    },
  ],
};

export const planData = {
  title: "Subscription Plan",
  cardData: [
    {
      isPopular: false,
      plan: "Basic",
      price: 0,
      isPaid: false,
      planDuration: "Year",
      currency: "₹",
      payService: false,
      planChecklist: ["Model Portfolio", "Tracking & Analytics on Portfolio"],
    },
    {
      isPopular: true,
      plan: "Standard",
      price: "10,000",
      isPaid: true,
      planDuration: "Year",
      currency: "₹",
      payService: false,
      planChecklist: [
        "Model Portfolio",
        "Tracking & Analytics on Portfolio",
        "Equity & Mutual Fund Reports & Videos",
        "Relationship Manager",
      ],
    },
    {
      isPopular: false,
      plan: "Advance",
      price: "15,000",
      isPaid: true,
      planDuration: "Year",
      currency: "₹",
      payService: true,
      planChecklist: [
        "Model Portfolio",
        "Tracking & Analytics on Portfolio",
        "Equity & Mutual Fund Reports & Video",
        "Relationship Manager",
        "Sectoral & Theme based Investing",
      ],
    },
  ],
};

export const planDataMobile = [
  {
    isPopular: true,
    plan: "Standard",
    price: "10,000",
    isPaid: true,
    planDuration: "Year",
    currency: "₹",
    payService: false,
    planChecklist: [
      "Model Portfolio",
      "Tracking & Analytics on Portfolio",
      "Equity & Mutual Fund Reports & Videos",
      "Relationship Manager",
    ],
  },
  {
    isPopular: false,
    plan: "Basic",
    price: 0,
    isPaid: false,
    planDuration: "Year",
    currency: "₹",
    payService: false,
    planChecklist: ["Model Portfolio", "Tracking & Analytics on Portfolio"],
  },
  {
    isPopular: false,
    plan: "Advance",
    price: "15,000",
    isPaid: true,
    planDuration: "Year",
    currency: "₹",
    payService: true,
    planChecklist: [
      "Model Portfolio",
      "Tracking & Analytics on Portfolio",
      "Equity & Mutual Fund Reports & Video",
      "Relationship Manager",
      "Sectoral & Theme based Investing",
    ],
  },
];

export const sidebarData = () => {
  const store = useUserStore();

  return {
    logo: ANLogo,
    listData: {
      Dashboard: {
        label: "Dashboard",
        component: UserDashboard,
        icon: Dashboard,
        tabs: [
          {
            id: "portfolio",
            label: "My Portfolio",
            component: MyPortfolio,
            selected: true,
          },
          {
            id: "myStatement",
            label: "Financial Status",
            component: FinancialStatements,
            selected: false,
          },
        ],
      },
      ManageProfile: {
        label: "Complete Profile",
        component: ManageUserProfile,
        icon: User,
        tabs: false,
      },
      KYCVerification: {
        label: "KYC Verification",
        component: KYCVerification,
        icon: User,
        tabs: false,
      },
      AgreementSigning: {
        label: "Sign Agreement",
        component: AgreementSigning,
        icon: User,
        tabs: false,
      },
      PaymentQRCode: {
        label: "Complete Payment",
        component: PaymentQRCode,
        icon: User,
        tabs: false,
      },
      PaymentStatus: {
        label: "Payment Status",
        component: PaymentStatus,
        icon: User,
        tabs: false,
      },
      MyModelPortfolio: {
        label: "Model Portfolio",
        component: MyModelPortfolio,
        icon: Analysis,
        tabs: false,
      },
      "My Goals": {
        label: "My Goals",
        component: MyGoalsScreen,
        icon: MyGoals,
        tabs: false,
        action: () => !store.goalSummary && store.loadGoalSummary(),
      },
      "Stock Screener": {
        label: "Stock Screener",
        component: StockScreeners,
        icon: StockScreener,
        tabs: false,
        action: () => !store.screenerData && store.getScreenerData(),
      },
      "Mutual Fund Recommender": {
        label: "Mutual Fund Recommender",
        component: MutualFundRecommender,
        icon: StockSelection,
        tabs: false,
      },
      "Stock Analysis": {
        label: "Stock Analysis",
        component: StockAnalysisView,
        icon: StockAnalysis,
        tabs: false,
      },
      "Portfolio Analytics": {
        label: "Portfolio Analytics",
        component: PortfolioAnalytics,
        icon: Analysis,
        tabs: false,
        action: () => !store.portfolioAnalyticsData && store.getPortfolioAnalyticsData(),
      },
      "Planning Tools": {
        label: "Planning Tools",
        component: PlanningTool,
        icon: Planning,
        tabs: false,
      },
      "Operations Support": {
        label: "Ask for help",
        component: ContactUsScreen,
        icon: ContactUs,
        tabs: false,
      },
      "Monthly Market Update": {
        label: "Monthly Market Update",
        component: MonthlyMarketUpdate,
        icon: Newsletter,
        tabs: false,
      },
      "Blogs & videos": {
        label: "Blogs & videos",
        component: BlogsVideos,
        icon: Blogs,
        tabs: false,
      },
      // commenting quaterly results for now as we are not able to get the data for it, will add it back once we have the data and screen ready
      /*"Quaterly Results": {
        label: "Quaterly Results",
        component: PlanningTool,
        icon: QuaterResults,
        tabs: false,
      },*/


    },
  };
};

// Enhanced getFilteredSidebarData that handles loading states properly
export const getFilteredSidebarData = () => {
  try {
    const store = useUserStore();

    // Safety check - if store is not available, return minimal data
    if (!store) {
      console.warn('Store not available in getFilteredSidebarData');
      return {
        logo: ANLogo,
        listData: {}
      };
    }

    // Get base sidebar data
    const baseSidebarData = sidebarData();

    // If no dashboard data yet (initial load), show loading message with disabled items
    if (!store.dashboardData) {
      const disabledItems = {};
      Object.keys(baseSidebarData.listData).forEach(key => {
        if (key !== 'ManageProfile' && key !== 'Operations Support') {
          disabledItems[key] = {
            ...baseSidebarData.listData[key],
            disabled: true
          };
        }
      });

      //console.log('No dashboard data - disabled items:', Object.keys(disabledItems));

      return {
        logo: baseSidebarData.logo,
        listData: {
          ManageProfile: baseSidebarData.listData.ManageProfile,
          ...disabledItems,
          'Operations Support': baseSidebarData.listData['Operations Support']
        }
      };
    }

    const { dashboardData } = store;
    const customerId = dashboardData.customerId;
    const isValidCustomerId = customerId &&
                             customerId !== "None" &&
                             customerId !== "" &&
                             !isNaN(parseInt(customerId));

    // CONDITION 1: No valid customerId → Show Complete Profile + disabled dashboard items
    if (!isValidCustomerId) {
      const disabledItems = {};
      Object.keys(baseSidebarData.listData).forEach(key => {
        if (key !== 'ManageProfile' && key !== 'KYCVerification' &&
            key !== 'PaymentQRCode' && key !== 'PaymentStatus' &&
            key !== 'Operations Support') {
          disabledItems[key] = {
            ...baseSidebarData.listData[key],
            disabled: true
          };
        }
      });

      return {
        logo: baseSidebarData.logo,
        listData: {
          ManageProfile: baseSidebarData.listData.ManageProfile,
          ...disabledItems,
          'Operations Support': baseSidebarData.listData['Operations Support']
        }
      };
    }

    // Valid customerId exists - check KYC, doc signing, payment status and risk assessment
    const kycStatus = dashboardData.kycStatus; // Will be added to dashboardData
    const docSigningStatus = dashboardData.docSigningStatus; // Doc signing status from backend
    const paymentStatus = dashboardData.paymentStatus;
    const portfolioTargetAlloc = dashboardData.portfolioTargetAlloc || [];
    const hasCompletedRiskAssessment = Array.isArray(portfolioTargetAlloc) && portfolioTargetAlloc.length > 0;

    console.log('Customer ID:', customerId, 'KYC Status:', kycStatus, 'Doc Signing:', docSigningStatus, 'Payment Status:', paymentStatus, 'Risk Assessment Done:', hasCompletedRiskAssessment);

    // CONDITION 2: KYC not completed - Show KYC Verification + Operations Support
    console.log('KYC check - kycStatus:', kycStatus);

    // Check if KYC is NOT done (null, undefined, Submitted, Pending, InProgress, or any value except 'Done' or 'Verified')
    if (!kycStatus || (kycStatus !== 'Done' && kycStatus !== 'Verified')) {
      console.log('KYC not completed - showing KYCVerification');
      const filteredData = {
        KYCVerification: baseSidebarData.listData.KYCVerification,
        "Operations Support": baseSidebarData.listData["Operations Support"]
      };
      console.log('Sidebar items (KYC incomplete):', Object.keys(filteredData));
      return {
        logo: baseSidebarData.logo,
        listData: filteredData
      };
    }

    // CONDITION 2.5: KYC completed but Agreement not Verified - Show Agreement Signing + Operations Support
    // Check doc signing status from backend API (stored in dashboardData)
    const agreementVerified = docSigningStatus === 'Verified';

    if ((kycStatus === 'Done' || kycStatus === 'Verified') && !agreementVerified) {
      console.log('KYC verified but agreement not verified - showing AgreementSigning');
      const filteredData = {
        AgreementSigning: baseSidebarData.listData.AgreementSigning,
        "Operations Support": baseSidebarData.listData["Operations Support"]
      };
      console.log('Sidebar items (Agreement not verified):', Object.keys(filteredData));
      return {
        logo: baseSidebarData.logo,
        listData: filteredData
      };
    }

    // CONDITION 3: Payment not completed - Show Payment + Operations Support
    if (paymentStatus === 'Initiated' || !paymentStatus) {
      const disabledItems = {};
      Object.keys(baseSidebarData.listData).forEach(key => {
        if (key !== 'ManageProfile' && key !== 'KYCVerification' &&
            key !== 'PaymentQRCode' && key !== 'PaymentStatus' &&
            key !== 'Operations Support') {
          disabledItems[key] = {
            ...baseSidebarData.listData[key],
            disabled: true
          };
        }
      });

      //console.log('Payment not completed - disabled items:', Object.keys(disabledItems));

      return {
        logo: baseSidebarData.logo,
        listData: {
          PaymentQRCode: baseSidebarData.listData.PaymentQRCode,
          ...disabledItems,
          'Operations Support': baseSidebarData.listData['Operations Support']
        }
      };
    }

    // CONDITION 4: Payment status = "Paid" → Show Payment Status + disabled dashboard items
    if (paymentStatus === 'Paid') {
      const disabledItems = {};
      Object.keys(baseSidebarData.listData).forEach(key => {
        if (key !== 'ManageProfile' && key !== 'KYCVerification' &&
            key !== 'PaymentQRCode' && key !== 'PaymentStatus' &&
            key !== 'Operations Support') {
          disabledItems[key] = {
            ...baseSidebarData.listData[key],
            disabled: true
          };
        }
      });

      return {
        logo: baseSidebarData.logo,
        listData: {
          PaymentStatus: baseSidebarData.listData.PaymentStatus,
          ...disabledItems,
          'Operations Support': baseSidebarData.listData['Operations Support']
        }
      };
    }

    console.log('Payment Status:', paymentStatus);
    // CONDITION 4: Payment status = "Verified" → Check risk assessment completion
    if (paymentStatus === 'Verified') {
      // If risk assessment not done, show only MyModelPortfolio + Operations Support
      if (!hasCompletedRiskAssessment) {
        const disabledItems = {};
        Object.keys(baseSidebarData.listData).forEach(key => {
          if (key !== 'ManageProfile' && key !== 'KYCVerification' &&
              key !== 'PaymentQRCode' && key !== 'PaymentStatus' &&
              key !== 'MyModelPortfolio' && key !== 'Operations Support') {
            disabledItems[key] = {
              ...baseSidebarData.listData[key],
              disabled: true
            };
          }
        });

        console.log('Payment Verified but risk assessment pending - showing MyModelPortfolio');

        return {
          logo: baseSidebarData.logo,
          listData: {
            MyModelPortfolio: baseSidebarData.listData.MyModelPortfolio,
            ...disabledItems,
            'Operations Support': baseSidebarData.listData['Operations Support']
          }
        };
      }

      // Risk assessment completed - show full dashboard (remove ManageProfile, KYCVerification, AgreementSigning, and payment components)
      const { ManageProfile, KYCVerification, AgreementSigning, PaymentQRCode, PaymentStatus, ...fullDashboard } = baseSidebarData.listData;
      console.log('Payment Verified and risk assessment done - showing full dashboard with items:', Object.keys(fullDashboard));
      return {
        logo: baseSidebarData.logo,
        listData: fullDashboard
      };
    }

    // CONDITION 5: No payment record → Show Complete Payment + disabled dashboard items
    const disabledItems = {};
    Object.keys(baseSidebarData.listData).forEach(key => {
      if (key !== 'ManageProfile' && key !== 'PaymentQRCode' &&
          key !== 'PaymentStatus' &&
          key !== 'Operations Support') {
        disabledItems[key] = {
          ...baseSidebarData.listData[key],
          disabled: true
        };
      }
    });

    console.log('No payment record - showing PaymentQRCode');

    return {
      logo: baseSidebarData.logo,
      listData: {
        PaymentQRCode: baseSidebarData.listData.PaymentQRCode,
        ...disabledItems,
        'Operations Support': baseSidebarData.listData['Operations Support']
      }
    };
  } catch (error) {
    console.error('Error in getFilteredSidebarData:', error);
    return {
      logo: ANLogo,
      listData: {
        ManageProfile: sidebarData().listData.ManageProfile
      }
    };
  }
};

export const awsConfig = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id:
    "us-east-1:5402e37e-7c31-43f2-aa8b-a12c5db2b962",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_d93m9NGUJ",
  aws_user_pools_web_client_id: "20tgor48n6ke68lmjipq1fg3ss",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export const chartColors = [
  "#42A5F5",
  "#66BB6A",
  "#FFA726",
  "#AB47BC",
  "#26A69A",
  "#EF5350",
  "#EC407A",
  "#7E57C2",
  "#FFCA28",
  "#29B6F6",
  "#9CCC65",
  "#FF7043",
  "#8D6E63",
  "#26C6DA",
  "#BDBDBD",
  "#5C6BC0",
  "#FF8A65",
  "#D4E157",
  "#FFB74D",
  "#4DB6AC",
  "#BA68C8",
  "#81C784",
  "#7986CB",
  "#A1887F",
  "#AED581",
  "#4FC3F7",
  "#F06292",
  "#9575CD",
  "#E57373",
  "#FFD54F",
];

export const donutChartOptions = {
  cutout: "60%",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        enabled: true,
        label: (tooltipItem) => {
          let value = tooltipItem.raw;
          return ` ${value}%`;
        },
      },
      bodyFont: {
        size: 14,
      },
      bodySpacing: 8,
      usePointStyle: true,
    },
  },
};

export const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        enabled: true,
        label: (tooltipItem) => {
          let value = tooltipItem.raw;
          return ` ${value}%`;
        },
      },
      bodyFont: {
        size: 14,
      },
      bodySpacing: 8,
      usePointStyle: true,
    },
  },
};

export const lineChartOptions = (flag, zero = false, rolling = false) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
        ticks: {
          display: true,
        },
        border: {
          display: true,
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        ticks: {
          display: true,
          callback: function (value) {
            return convertToInr(value);
          },
        },
        border: {
          display: false,
        },
        beginAtZero: zero,
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        intersect: false,
        displayColors: false,
        mode: "index",
        callbacks: {
          title: () => {
            return null;
          },
          label: (tooltipItem) => {
            const datasetLabel = tooltipItem.dataset.label || "";
            const date = tooltipItem.label;
            const value = tooltipItem.parsed.y ?? 0;
            const valueLine = `${date}: ${
              rolling
                ? value + "%"
                : value.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                  })
            }`;

            return flag ? valueLine : [datasetLabel, valueLine];
          },
        },
      },
      legend: {
        display: false,
      },
    },
  };
};

export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      display: true,
      grid: {
        display: false,
      },
      ticks: {
        display: true,
      },
      border: {
        display: false,
      },
    },
    y: {
      display: true,
      grid: {
        display: true,
      },
      ticks: {
        display: true,
        callback: function (value) {
          return convertToInr(value);
        },
      },
      border: {
        display: false,
      },
    },
  },
  plugins: {
    tooltip: {
      intersect: false,
      displayColors: false,
      mode: "index",
      callbacks: {
        title: () => {
          return null;
        },
        label: (tooltipItem) => {
          const date = tooltipItem.label;
          const value = tooltipItem.parsed.y ?? 0;
          const valueLine = `${date}: ${value.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
          })}`;

          return valueLine;
        },
      },
    },
    legend: {
      display: false,
    },
  },
};

export const gridHighlightPlugin = {
  id: "highlightLineOnHover",
  beforeTooltipDraw(chart) {
    if (chart.tooltip._active && chart.tooltip._active.length) {
      const ctx = chart.ctx;
      const x = chart.tooltip._active[0].element.x;
      const topY = chart.scales.y.top;
      const bottomY = chart.scales.y.bottom;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 1;
      // ctx.strokeStyle = "#4bc0c0";
      ctx.setLineDash([5, 5]);
      ctx.stroke();
      ctx.restore();
    }
  },
};

export const opportunities = [
  {
    label: "Equity Analysis",
    route: "Stock Analysis"
  },
  {
    label: "Mutual Funds Recommendations",
    route: "Mutual Fund Recommender"
  },
  {
    label: "Explore PMS & AIFS",
    route: null
  },
  {
    label: "Explore SIF",
    route: null
  },
  {
    label: "Model Portfolio",
    route: "MyModelPortfolio"
  },
];

export const goalOptions = [
  {
    label: "Buy Home",
    icon: BuyHome,
  },
  {
    label: "Child Education",
    icon: ChildEducation,
  },
  {
    label: "Children Marriage",
    icon: ChildMarriage,
  },
  {
    label: "Getting Married",
    icon: GettingMarried,
  },
  {
    label: "Start Business",
    icon: NewBusiness,
  },
  {
    label: "Retirement",
    icon: Retirement,
  },
];

export const riskAssessmentSection = {
  title: "Discover Your Investment Strategy",
  subtitle: "Take our comprehensive risk assessment to get a personalized asset allocation recommendation",
  buttonText: "Assess Your Risk Profile",
  features: [
    "6 simple questions",
    "Personalized recommendations",
    "Professional asset allocation model",
    "Free assessment"
  ]
};

export const apis = {
  getPortfilioDashboardData:
    "https://9cdgxm0w2l.execute-api.us-east-1.amazonaws.com",
  getGoalSummary:
    "https://92r3unu78f.execute-api.us-east-1.amazonaws.com/default/",
  getFinancialStatement:
    "https://x0z9owmumc.execute-api.us-east-1.amazonaws.com/default/",
  postGoalData:
    "https://448vx0o9b8.execute-api.us-east-1.amazonaws.com/default/",
  getMutualFundData:
    "https://7tqbu7jwrc.execute-api.us-east-1.amazonaws.com/default/",
  getStockData:
    "https://wd8ymrd6dk.execute-api.us-east-1.amazonaws.com/default/",
  postStockData:
    "https://usnr7hvzq2.execute-api.us-east-1.amazonaws.com/default/",
  getStockMFCurrentPrice:
    "https://utma8cw52i.execute-api.us-east-1.amazonaws.com/default/",
  getScreenerData:
    "https://s3mlv84k6k.execute-api.us-east-1.amazonaws.com/default/",
  getPortfolioAnalyticsData:
    "https://lgw9vw4mo5.execute-api.us-east-1.amazonaws.com/default/",
  getRiskAssessment:
    "https://nxtljap3mf.execute-api.us-east-1.amazonaws.com/default/",
  getBenchmarkData:
    "https://e6nzxcn7pk.execute-api.us-east-1.amazonaws.com/default/",
  getPortfolioAttributionData:
    "https://03su6a8b2h.execute-api.us-east-1.amazonaws.com/default/",
  getMutualFundRecommender:
    "https://klg7hn3n6j.execute-api.us-east-1.amazonaws.com/default/",
  getStockValuationParams:
    "https://tgee0mgi09.execute-api.us-east-1.amazonaws.com/default/",
  getStockTechData:
    "https://h9hwlb7qjj.execute-api.us-east-1.amazonaws.com/default/",
  addMutualFund:
    "https://52eo881b17.execute-api.us-east-1.amazonaws.com/default/",
  getBlogsVideos:
    "https://msi0dhirdh.execute-api.us-east-1.amazonaws.com/default/",
  updateFinancialStatement:
    "https://c7fiynq5kj.execute-api.us-east-1.amazonaws.com/default/",
  getRecommendationSummary:
    "https://n3bwjt252b.execute-api.us-east-1.amazonaws.com/default/",
  createUserProfile:
    "https://m69igwdro8.execute-api.us-east-1.amazonaws.com/default/",
  getModelPortfolioHistReturns:
    "https://4njbrghk3h.execute-api.us-east-1.amazonaws.com/default/",
  addFixedIncomeData:
    "https://fnmv706qbc.execute-api.us-east-1.amazonaws.com/default/",
  addOtherInvestments:
    "https://upbltl1wjl.execute-api.us-east-1.amazonaws.com/default/",
  getAssetAllocationDebugInfo:
    "https://twtz9t4bu7.execute-api.us-east-1.amazonaws.com/default/",
  publishRecommendationEvent:
    "https://vfykevu8t3.execute-api.us-east-1.amazonaws.com/default/",
  authenticateAndRedirectToAA:
    "https://3tqomnykvb.execute-api.us-east-1.amazonaws.com/default/",
  logCustomerSupportTicket:
    "https://a7gdc38z9e.execute-api.us-east-1.amazonaws.com/default/",
  getCustomerSupportTickets:
    "https://j37mwsmdek.execute-api.us-east-1.amazonaws.com/default/",
  updateCustomerPaymentStatus:
    "https://09bn4m8mla.execute-api.us-east-1.amazonaws.com/default/",
  getCustomerPaymentStatus:
    "https://gewurjplmk.execute-api.us-east-1.amazonaws.com/default/",
  getPANKRAStatus:
    "https://gwpzmludri.execute-api.us-east-1.amazonaws.com/default/",
  createKYCRequests:
    "https://0lk2rzvx5e.execute-api.us-east-1.amazonaws.com/default/",
  getKYCRequestStatus:
    "https://g57a98ddy4.execute-api.us-east-1.amazonaws.com/default/",
  updateKYCRequestStatus:
    "https://phrglzpv83.execute-api.us-east-1.amazonaws.com/default/",
  createDocSigningRequest:
    "https://iww1l8byil.execute-api.us-east-1.amazonaws.com/default/",
  getDocSigningStatus:
    "https://02cjb5damh.execute-api.us-east-1.amazonaws.com/default/",
  updateDocSigningStatus:
    "https://gl8674h26i.execute-api.us-east-1.amazonaws.com/default/",
};

// This function is no longer needed since we handle internal navigation differently
